function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-aaa",
  x1: 0.226,
  x2: 0.752,
  y1: 0.005,
  y2: 0.955,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ffae52"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.059,
  stopColor: "#fea452"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.156,
  stopColor: "#fc8b54"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.279,
  stopColor: "#f86356"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.421,
  stopColor: "#f42b5a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.518,
  stopColor: "#f1025d"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.713,
  stopColor: "#d81a82"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#af42c1"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_23853",
  fill: "url(#linear-aaa)",
  d: "M817.832 460.576c0 154.825-125.51 280.335-280.335 280.335S257.162 615.4 257.162 460.576 382.672 180.241 537.5 180.241c111.818 0 208.345 65.467 253.343 160.162a182.493 182.493 0 0 1 9.048 22.346c4.8 15.579 9.175 28.676 13 44.677 1.92 8.14 2.9 19.29 3.8 27.634q1.132 12.605 1.141 25.516z",
  "data-name": "Path 23853",
  transform: "translate(-257.162 -180.241)"
});

var SvgCircle = function SvgCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560.67,
    height: 560.67,
    viewBox: "0 0 560.67 560.67",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle.b2e19565.svg";
export { ForwardRef as ReactComponent };